const state = {
    serverBinNoticePending: false,
};

const getters = {
    serverBinNoticePending: state => state.serverBinNoticePending,
};

const mutations = {
    setServerBinNoticePending(state, value) {
        state.serverBinNoticePending = value;
    },
};

export default {
    state,
    getters,
    mutations,
};
